import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone, faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from '../contexts/LanguageContext';

function Footer() {
    const {getTranslation} = useLanguage();
    return (
        <footer className="bg-primary font-raleway text-white px-8 py-5">
            <div className="max-w-7xl mx-auto flex flex-col gap-7 fmd:grid fmd:grid-cols-2 fmd:grid-rows-2 lg:flex lg:flex-row lg:justify-between">
                <div>
                    <h1 className="font-bold uppercase tracking-wider mb-4 text-lg">Pinnipedia</h1>
                    <p className="text-normal">
                        {getTranslation("Một kho tàng tài nguyên miễn phí cho người học tiếng Anh ở mọi trình độ.",
                                        "An ever-growing collection of free English resources for learners of all levels.")}
                        <br/>
                        Copyright © 2022 First Aid Kid
                    </p>
                </div>
                <div>
                    <h1 className="font-bold uppercase tracking-wider mb-4 text-lg">
                        {getTranslation("Luyện tập", "Practice")}
                    </h1>
                    <ul>
                        {
                            [
                                ["Cơ bản", "Beginner", "/beginner"],
                                ["Nâng cao", "Advanced", "/advanced"],
                                ["IELTS", "IELTS", "/ielts"],
                                ["Nghe thực tế", "Authentic listening", "/listening"]
                            ].map(([vn, en, path], index) => {
                                return <li key={index}>
                                    <Link to={path} className="hover:text-secondary">
                                        {getTranslation(vn, en)}
                                    </Link>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div>
                    <h1 className="font-bold uppercase tracking-wider mb-4 text-lg">
                        {getTranslation("Tài nguyên", "Resources")}
                    </h1>
                    <ul>
                        <li>
                            <Link className="hover:text-secondary" to="/news">
                                {getTranslation("Bài viết", "Posts")}
                            </Link>
                        </li>
                        <li>
                            <a className="hover:text-secondary" href="https://drive.google.com/drive/folders/1Lv7AVKpvgsv2Gfxcsi7BUZmq9RKj9bNV?usp=sharing" target="_blank" rel="noreferrer noopener">
                                {getTranslation("Danh sách từ vựng", "Vocabulary cheatsheets")}
                            </a>
                        </li>
                    </ul>    
                </div>
                <div>
                    <h1 className="font-bold uppercase tracking-wider mb-4 text-lg">
                        {getTranslation("Liên hệ", "Contact")}
                    </h1>
                    <ul>
                        {
                            [
                                ["Facebook", "Facebook", "https://www.facebook.com/pinnipedia2021", "_blank", "noreferrer noopener", faFacebookF],
                                ["Email", "Email", "mailto:pinnipedia.fak@gmail.com", "", "", faEnvelope],
                                ["Điện thoại", "Phone", "tel:0967972004", "", "", faPhone],
                                ["Phản hồi", "Feedback", "https://forms.gle/HJpbbxFycvRQNxfSA", "_blank", "noreferrer noopener", faCommentAlt],
                            ].map(([vn, en, href, target, rel, icon], index) => {
                                return <li key={index}>
                                    <a href={href} target={target} rel={rel} className="hover:text-secondary w-40 flex items-center">
                                        <FontAwesomeIcon icon={icon}/>
                                        <span className="block ml-auto w-32">
                                            {getTranslation(vn, en)}
                                        </span>
                                    </a>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;